import { render, staticRenderFns } from "./ExercismBowling.vue?vue&type=template&id=3cf982e8&"
import script from "./ExercismBowling.vue?vue&type=script&lang=js&"
export * from "./ExercismBowling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports